import { render, staticRenderFns } from "./CompanyFormRequestStatus.vue?vue&type=template&id=d2086422&"
import script from "./CompanyFormRequestStatus.vue?vue&type=script&lang=js&"
export * from "./CompanyFormRequestStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports